const axios = require("axios").default;

const backend = axios.create({ baseURL: "https://apim.247prod.io/finance/v1" });

const vehicleService = {
    vehicleLookup(reg) {
      return new Promise(async (resolve, reject) => {

        try{
            let vehicle = null;
  
            // First try vehicle search
            const searchTask = backend.get(
              `/vehicle-search?vrm=${reg.toUpperCase().replace(" ", "")}`
            ).then(res => {
                if (res.data.vehicleId) {
                  vehicle = {
                    vehicleId: res.data.vehicleId,
                    make: res.data.make,
                    model: res.data.model,
                    vehicleDateOfFirstReg: res.data.registrationDate ? new Date(res.data.registrationDate) : null,
                    regYear: res.data.regYear,
                    vrm: res.data.regNumber,
                    fuel: res.data.fuel,
                    colour: res.data.colour,
                    mileage: res.data.mileage,
                    price: res.data.price,
                    transmission: res.data.trans,
                    isIntranetLoanVehicle: false,
                    year: res.data.registrationDate ? new Date(res.data.registrationDate).getFullYear() : null,
                    glassesRetailValuation: res.data.glassesRetailValuation,
                    glassesTradeValuation: res.data.glassesTradeValuation,
                    glassesRetailTransacted: res.data.glassesRetailTransacted,
                    futures: res.data.vehicleResiduals ? JSON.parse(res.data.vehicleResiduals) : null,
                    vehicleResiduals: res.data.vehicleResiduals,
                    capCode: "",//res.data.capCode
                    capRetail: res.data.capRetail,
                    capAverage: res.data.capAverage,
                    capClean: res.data.capClean,
                    capCreatedOn: res.data.capCreatedOn,
                    capId: res.data.capId,
                    image: res.data.image,
                    images: res.data.images,
                    vin: res.data.vin,
                  };
                }
              }).catch(error => {
                vehicle = null;
              })
      
            await searchTask;

            // Do a cap lookup
            const capTask = backend.get(
              `/vehicle-cap/${reg}/true?source=PricingLibrary`
            ).then(async (res) => {

              let capVehicle = res.data;
      
              // Rare cases of reg switch, cap lookup for a reg will return
              // a different reg with no capcode, researching by that reg
              // returns a cap code
              if (capVehicle.capCode === null) {
                const response = await backend.get(
                  `/vehicle-cap/${capVehicle.vehicleRegistration}/true?source=PricingLibrary`
                )
                const regSwitch = response.data;
                if (regSwitch.capCode) {
                  capVehicle = regSwitch;
                }
              }
              // if just missing capcode, use that
              if (vehicle) {
                vehicle.capCode = capVehicle.capCode ? capVehicle.capCode : vehicle.capCode;
                vehicle.capId = capVehicle.capId ? capVehicle.capId : vehicle.capId;
                vehicle.make = capVehicle.make ? capVehicle.make : vehicle.make;
                vehicle.model = capVehicle.model ? capVehicle.model : vehicle.model;
                vehicle.vin = capVehicle.vin ? capVehicle.vin : vehicle.vin;
                vehicle.vehicleRegistration = capVehicle.vehicleRegistration ? capVehicle.vehicleRegistration : vehicle.vehicleRegistration;
                vehicle.vehicleDateOfFirstReg = capVehicle.vehicleDateOfFirstReg ? capVehicle.vehicleDateOfFirstReg : vehicle.vehicleDateOfFirstReg;
              }
              else {
                // Use the cap lookup vehicle
             
                // Some rare cases of cap lookup only returning a date of reg, no make / model
                // Do not allow to quote
                if (capVehicle.make) {
                  vehicle = {
                    vehicleId: capVehicle.vehicleId,
                    make: capVehicle.make,
                    model: capVehicle.model,
                    mileage: 0,
                    vrm: capVehicle.vehicleRegistration,
                    vehicleDateOfFirstReg: capVehicle.vehicleDateOfFirstReg ? new Date(capVehicle.vehicleDateOfFirstReg) : null,
                    price: capVehicle.price,
                    vehicleCondition: capVehicle.vehicleCondition,
                    fuel: capVehicle.fuelType,
                    transmission: capVehicle.transmission,
                    annualMileage: capVehicle.annualMileage,
                    capId: capVehicle.capId,
                    capCode: capVehicle.capCode,
                    capCreatedOn: capVehicle.capCreatedOn ? new Date(capVehicle.capCreatedOn) : null,
                    capAverage: capVehicle.capAverage,
                    capClean: capVehicle.capClean,
                    capRetail: capVehicle.capRetail,
                    colour: capVehicle.colour,
                    glassCode: capVehicle.glassCode,
                    glassesEffectiveFrom: capVehicle.glassesEffectiveFrom ? new Date(capVehicle.glassesEffectiveFrom) : null,
                    glassesRetailTransacted: capVehicle.glassesRetailTransacted,
                    glassesRetailValuation: capVehicle.glassesRetailValuation,
                    glassesTradeValuation: capVehicle.glassesTradeValuation,
                    vin: capVehicle.vin,
                  };
                }
              }
            }).catch(error => {
              
            })
      
            await capTask;
       
            if (vehicle) {
              vehicle.image = 'https://res.cloudinary.com/carfinance247-co-uk/image/upload/q_10/v1/' + vehicle.vehicleId + '/1.webp'
      
              resolve(vehicle);
            }
      
            reject(null);
        }catch(error){
            reject(error);
        }
      })
    },
    getResiduals(req) {
      return new Promise((resolve, reject) => {
        backend.post(`/v2/vehicle/residuals/multiple`, req).then(res => {
          if (res.status === 204) {
            resolve(null);
          }
          resolve(res.data);
        }).catch(error => {
          reject(error);
        })
      })
    },
  };
  
  module.exports = { vehicleService }